import { Breadcrumb } from "flowbite-react";
import { H4 } from "../typography/H4";

interface Props {}

export const PartnerHeader: React.FC<Props> = ({}) => {
  return (
    <div className="flex flex-col">
      <Breadcrumb>
        <Breadcrumb.Item>파트너 관리</Breadcrumb.Item>
        <Breadcrumb.Item>파트너 관리</Breadcrumb.Item>
      </Breadcrumb>
      <div className="flex items-center justify-between">
        <div className="mt-[14px] mb-[16px]">
          <H4>파트너 관리</H4>
        </div>
        <div />
      </div>
    </div>
  );
};
